import React, {useState} from 'react'
import {ListItem, Tooltip, Typography, withStyles} from '@material-ui/core';
import Button from 'components/Button';
import PropTypes from 'prop-types'
import AddIcon from '@material-ui/icons/Add'
import Tr from 'translations/Translations'
// import NewForm from 'components/popup/newForm/NewForm';
import NewProcedureMenu from './newProcedureMenu/NewProcedureMenu';
import menuItems from './newProcedureMenu/ListElements.values'

const style = theme => ({
    button: {
        minWidth: 'unset',
        padding: 0,
    },
    text: {
        marginBottom: -1,
        marginLeft: theme.spacing(1)
    },
    buttonTooltipWraper: {
        display: 'flex'
    }
})

function ListAddButton(
    {
        open,
        procedures,
        classes
    }) {
    // const [openCreateNew, setOpenCreateNew] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)

    const handleClick = (e) => {
        // setOpenCreateNew(true)
        setAnchorEl(anchorEl ? null : e.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const buttonLabel = open ?
        <>
            <AddIcon/>
            <Typography
                variant='body1'
                noWrap
                className={classes.text}
            >
                {Tr('new2')}
            </Typography>
        </>
        : <AddIcon/>


    return (
        <ListItem>
            <Button
                onClick={handleClick}
                className={classes.button}
                fullWidth
                size="small"
            >
                <Tooltip title={Tr('create_new_procedure')}>
                    <div className={classes.buttonTooltipWraper}>
                        {buttonLabel}
                    </div>
                </Tooltip>
            </Button>
            {/* <NewForm open={openCreateNew} setOpen={setOpenCreateNew} /> */}
            <NewProcedureMenu
                anchorEl={anchorEl}
                items={menuItems(procedures)}
                onClose={handleClose}
            />
        </ListItem>

    )
}

ListAddButton.propTypes = {
    open: PropTypes.bool,
    className: PropTypes.string,
}

ListAddButton.defaultProps = {
    open: false,
}

export default withStyles(style)(ListAddButton)
